import React, { Component } from "react";
import { Modal, Form, Input, Row, Col, Radio, Divider, List, Button, Select } from "antd";
import { createUser, updateUser, listUserBranches, setUserBranch, listAvailableRoutes } from "../../services/user";
import { getBranches } from "../../services/branch";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { getRouteByBranch } from "../../services/route";

const confirm = Modal.confirm;
const { Option } = Select;

class UserFormModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            confirmPasswordValidateStatus: undefined,
            confirmPasswordValidateMessage: undefined,
            userBranches: [],
            selectedAddBranchId: undefined,
            branchChoices: [],
            routeChoices: [],
            selectedCurrentRouteId: undefined,
            allBranches: [],
            selectedRole: "BRANCH_MANAGER"
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onFormDataChanged = this.onFormDataChanged.bind(this);
        this.prepareForm = this.prepareForm.bind(this)
        this.getUserBranchData = this.getUserBranchData.bind(this)
        this.onUserBranchDeleteClick = this.onUserBranchDeleteClick.bind(this)
        this.getBranchChoices = this.getBranchChoices.bind(this)
        this.filterBranchChoices = this.filterBranchChoices.bind(this)
        this.onBranchSelected = this.onBranchSelected.bind(this)
        this.formRef = React.createRef();
    }

    async onFormSubmit() {
        const { data, editing, setVisible, reloadData, reloadAfterCreate } = this.props;
        const { selectedCurrentRouteId, userBranches } = this.state
        let values;
        let passed = true;
        try {
            values = await this.formRef.current.validateFields()
        }
        catch (err) {
            values = err.values
            passed = false
        }

        if (passed) {
            if (!editing) {
                await createUser(values)
                reloadAfterCreate();
            }
            else {
                if (values['role'] === "SALESMAN"){
                    values['current_route_id'] = selectedCurrentRouteId
                }
                await updateUser(data['id'], values)
                const branchIds = userBranches.map(ub => ub.branch.id)
                await setUserBranch(data['id'], branchIds)
                reloadData();
            }
            setVisible(false);
        }

    };

    onFormDataChanged(changed, all) {
        // if (changed['password'] !== undefined) {
        //     if (changed['password'] !== all['confirm_password']) {
        //         this.setState({
        //             confirmPasswordValidateStatus: "error",
        //             confirmPasswordValidateMessage: "รหัสผ่านใหม่ไม่เหมือนกับช่องด้านบน"
        //         })
        //     }
        //     else {
        //         this.setState({
        //             confirmPasswordValidateStatus: "success",
        //             confirmPasswordValidateMessage: undefined
        //         })
        //     }

        // }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    async getBranchChoices() {
        const res = await getBranches("", { "branch.is_active": true }, 1, 1000000, "code", "ASC")
        this.setState({
            allBranches: res.data.branches
        })
    }
    
    filterBranchChoices() {
        const { userBranches, allBranches } = this.state
        // Remove choices that same as user branch
        const branchChoices = []
        for (let i = 0; i < allBranches.length; i++) {
            let dupe = false
            for (let j = 0; j < userBranches.length; j++) {
                if (userBranches[j].branch.id === allBranches[i].id) {
                    dupe = true
                }
            }
            if (!dupe) {
                branchChoices.push(allBranches[i])
            }
        }
        this.setState({
            branchChoices,
            selectedAddBranchId: undefined,
            selectedCurrentRouteId: undefined
        })
    }

    async getRouteChoices() {
        const { userBranches } = this.state;
        const branchIds = userBranches.map(ub => ub.branch.id)
        if (branchIds.length > 0){
            const res = await getRouteByBranch(branchIds)
            this.setState({
                routeChoices: res.data.routes
            })
        }
    }

    async getUserBranchData() {
        const { data } = this.props
        const res = await listUserBranches(data.id)
        this.setState({
            userBranches: res.data.user_branches
        })
    }

    async onBranchSelected(selectedAddBranchId) {
        const { userBranches, branchChoices } = this.state
        const { data } = this.props
            const selectedBranch = branchChoices.filter(bc =>
                {
                    return selectedAddBranchId === bc.id;
                })
            userBranches.push({branch: selectedBranch[0]})
            this.filterBranchChoices()
            this.getRouteChoices()
            this.setState({
                selectedAddBranchId
            }, ()=> {
                this.setState({selectedAddBranchId: undefined})
            })
    }

    onUserBranchDeleteClick(row) {
        const { userBranches } = this.state
        for (let i = 0; i<userBranches.length; i++){
            if (userBranches[i].id === row.id){
                userBranches.splice(i, 1);
            }
        }
        this.setState({
            userBranches
        }, () => {
            this.filterBranchChoices()
            this.getRouteChoices()
        })
    }

    async prepareForm() {
        await this.getBranchChoices()
        await this.getUserBranchData()
        this.filterBranchChoices()
        await this.getRouteChoices()
        const { data } = this.props
        this.setState({
            selectedRole: data.role,
            selectedCurrentRouteId: data.current_route_id
        })
    }


    render() {
        const { editing, visible, setVisible, data } = this.props;
        const { confirmPasswordValidateMessage, confirmPasswordValidateStatus,
             userBranches, branchChoices, routeChoices, selectedCurrentRouteId,
             selectedAddBranchId, selectedRole } = this.state;
        const roleOptions = [
            { name: "แอดมิน", value: "ADMIN" },
            { name: "ผู้จัดการสาขา", value: "BRANCH_MANAGER" },
            // { name: "พนักงานฝ่ายขาย", value: "SALESMAN" }
        ]
        return (
            <Modal
                visible={visible}
                onCancel={() => { setVisible(false) }}
                onOk={this.onFormSubmit}
                title={editing ? "แก้ไขรายการ" : "เพิ่มรายการ"}
                okText={editing ? "แก้ไข" : "เพิ่ม"}
                afterClose={this.clearForm}
                cancelText={"ปิด"}
                keyboard={false}
                maskClosable={false}
                destroyOnClose={true}
            >
                <Form
                    ref={this.formRef}
                    layout={'vertical'}
                    initialValues={data}
                    onValuesChange={this.onFormDataChanged}
                >
                    <Row gutter={12}>
                        <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Form.Item
                                hasFeedback
                                label="ชื่อผู้ใช้"
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่ชื่อผู้ใช้"
                                    }
                                ]}>
                                <Input disabled={editing} />
                            </Form.Item>
                        </Col>
                    </Row>
                    {!editing &&
                        <Row gutter={12}>
                            <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <Form.Item
                                    hasFeedback
                                    label="รหัสผ่าน"
                                    name="password"
                                    rules={[{ required: true, message: 'กรุณาใส่รหัสผ่านใหม่' }, { min: 8, message: 'ความยาวรหัสผ่านต้องมีจำนวน 8-12 ตัวอักษร' }, { max: 12, message: 'ความยาวรหัสผ่านต้องมีจำนวน 8-12 ตัวอักษร' }]}
                                >
                                    <Input type="password" />
                                </Form.Item>
                            </Col>
                            <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <Form.Item
                                    hasFeedback
                                    label="ยืนยันรหัสผ่าน"
                                    name="confirm_password"
                                    help={confirmPasswordValidateMessage}
                                    validateStatus={confirmPasswordValidateStatus}
                                >
                                    <Input type="password" />
                                </Form.Item>
                            </Col>
                        </Row>
                    }
                    <Row gutter={12}>
                        <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Form.Item
                                hasFeedback
                                label="ชื่อ"
                                name="first_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่ชื่อ"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Form.Item
                                hasFeedback
                                label="นามสกุล"
                                name="last_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่นามสกุล"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Form.Item
                            label="ตำแหน่ง"
                            name="role"
                            rules={[
                                {
                                    required: true,
                                    message: "กรุณาเลือกตำแหน่ง"
                                }
                            ]}
                        >
                            <Radio.Group defaultValue={undefined} onChange={e => {
                                this.setState({selectedRole: e.target.value});
                                if (e.target.value !== "SALESMAN") {
                                    this.setState({selectedCurrentRouteId: undefined})
                                }
                            }}>
                                {roleOptions.map(ro => <Radio key={ro.value} value={ro.value}>{ro.name}</Radio>)}
                            </Radio.Group>
                        </Form.Item>
                    </Row>
                    {editing && <div>
                        <Divider orientation="center">สาขาที่อยู่</Divider>
                        <Row>
                            <Col span={6} xs={0} sm={6} md={6} lg={6} xl={6} xxl={6}></Col>
                                <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <Select
                                    value={selectedAddBranchId}
                                    style={{ width: '100%', marginBottom: 10 }}
                                    placeholder="เลือกสาขาที่ต้องการเพิ่ม"
                                    optionFilterProp="children"
                                    onSelect={e => this.onBranchSelected(e)}
                                >
                                    {branchChoices.map(bc =>
                                        <Option key={bc.id} value={bc.id}>{bc.code} {bc.name}</Option>
                                    )}
                                </Select>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6} xs={0} sm={6} md={6} lg={6} xl={6} xxl={6}></Col>
                            <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <List
                                    bordered
                                    dataSource={userBranches}
                                    renderItem={item => (
                                        <List.Item
                                            actions={[<Button
                                                color="danger"
                                                variant="solid"
                                                shape="circle"
                                                size="small"
                                                icon={<DeleteOutlined />}
                                                onClick={() => this.onUserBranchDeleteClick(item, this.getBranchChoices)}
                                            />]}
                                        >
                                            {item.branch.code} {item.branch.name}
                                        </List.Item>
                                    )}
                                />
                            </Col>
                        </Row>
                        {selectedRole === "SALESMAN" && <div>
                            <Divider orientation="center">สายบริการปัจจุบัน</Divider>
                            <Row>
                                <Col span={6} xs={0} sm={6} md={6} lg={6} xl={6} xxl={6}></Col>
                                <Col span={12} xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                    <Select
                                        allowClear
                                        value={selectedCurrentRouteId}
                                        style={{ width: '100%', marginBottom: 10 }}
                                        placeholder="เลือกสายดำเนินการ"
                                        optionFilterProp="children"
                                        onSelect={e => this.setState({
                                            selectedCurrentRouteId: e
                                        })}
                                        onClear={e=> this.setState({
                                            selectedCurrentRouteId: null
                                        })}
                                    >
                                        {routeChoices.map(rc =>
                                            <Option key={rc.id} value={rc.id}>{rc.branch.code} {rc.name}</Option>
                                        )}
                                    </Select>
                                </Col>
                            </Row>
                        </div>}
                        
                    </div>}

                </Form>

            </Modal>
        );
    }
}

export default UserFormModal;